import { ControlType, FetchStatus, Property } from "../../../../../base/types"
import { ErrorMessage, Spinner } from "../../../../../widgets"
import { FC, useCallback } from "react"
import { NumberProperties, useNumberProperties } from "./NumberProperties"

import { IControlAttributes } from "../../../../../base/models"
import { InputLabel } from "../../InputLabel"
import { NumberField } from "./NumberField"
import { Registry } from "../../../../../base/register"
import { SimpleNumber } from "./SimpleNumber"

export const NumberComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, bindings, error } = useNumberProperties(props);
    const { label, required, title } = properties || {}
    const containerClass = label ? className : ''
    const inputClass = label ? '' : className

    const getNumberNode = useCallback(() => {
        const binding = bindings?.getBinding(Property.InitValue);
        switch (binding?.type) {
            case "Field":
                return <NumberField
                    id={control.controlId}
                    title={title}
                    name={binding.boundValue}
                    {...properties}
                    className={inputClass}
                />
            case "Const":
            case "Expression":
            default:
                return <SimpleNumber
                    id={control.controlId}
                    title={title}
                    {...properties}
                    value={binding?.value}
                    className={inputClass}
                />
        }

        // eslint-disable-next-line
    }, [properties, bindings, control])

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <InputLabel
        htmlFor={control.controlId}
        title={title}
        label={label}
        required={required}
        className={containerClass}>
        {getNumberNode()}
    </InputLabel>
}

Registry.addControl({
    id: "98bb86a5-35bf-42de-acb2-256d7b39080e",
    name: "Number Input",
    type: ControlType.NumberInput,
    properties: NumberProperties,
    component: NumberComponent,
    draftComponent: NumberComponent
})
